var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoDevelopScreen4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 560 352",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2196f3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325.69,205.29v6.1h8.47a7.14,7.14,0,0,1-3.23,4.72,9.8,9.8,0,0,1-5.24,1.38,9.3,9.3,0,0,1-9.32-9.33,9.46,9.46,0,0,1,.47-2.93,9.29,9.29,0,0,1,8.85-6.39,9.39,9.39,0,0,1,2.4.31,9.06,9.06,0,0,1,2.15.9,6.42,6.42,0,0,1,.65.41,6.5,6.5,0,0,1,.61.46l4.59-4.59a14.47,14.47,0,0,0-1.65-1.27c-.39-.26-.78-.51-1.19-.73s-.82-.43-1.25-.62c-.22-.1-.43-.19-.65-.27a15.58,15.58,0,0,0-2.73-.79l-.72-.12a16.08,16.08,0,0,0-2.21-.15,15.78,15.78,0,1,0,0,31.56A15,15,0,0,0,336,220a15.69,15.69,0,0,0,4.79-11.85,13.42,13.42,0,0,0-.36-2.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.54,
    y: 112.25,
    width: 93.89,
    height: 8.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.46,
    y: 126.98,
    width: 47.87,
    height: 4.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.54,
    y: 151.84,
    width: 91.13,
    height: 8.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.46,
    y: 166.56,
    width: 47.87,
    height: 4.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.54,
    y: 195.1,
    width: 91.13,
    height: 8.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.46,
    y: 209.83,
    width: 47.87,
    height: 4.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.07,108.57a9.67,9.67,0,1,0,9.67,9.67A9.66,9.66,0,0,0,183.07,108.57Zm-1.38,15.83-3.82-2.67,1.3-1.87,1.87,1.31,5.05-8.08,1.92,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.07,149.07a9.67,9.67,0,1,0,9.67,9.67A9.66,9.66,0,0,0,183.07,149.07Zm-1.38,15.84-3.82-2.68,1.3-1.86,1.87,1.3,5.05-8.08,1.92,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M364.22,64.85h-310A14.93,14.93,0,0,0,39.34,79.76V239.1A14.93,14.93,0,0,0,54.26,254H179.9v13.86a7.15,7.15,0,0,0-2.5.67L152.51,280.6c-4.3,2.09-2,6.55,3.32,6.55H262.65c5.43,0,7.65-4.56,3.2-6.6l-26.31-12.07a5.73,5.73,0,0,0-1-.34V254H364.22a14.93,14.93,0,0,0,14.92-14.91V79.76A14.93,14.93,0,0,0,364.22,64.85ZM376.38,239.1a12.17,12.17,0,0,1-12.16,12.15h-310A12.17,12.17,0,0,1,42.1,239.1V79.76A12.17,12.17,0,0,1,54.26,67.61h310a12.17,12.17,0,0,1,12.16,12.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M511.71,88.32H433a9,9,0,0,0-8.94,9V278.21a9,9,0,0,0,8.94,8.94h78.76a9,9,0,0,0,8.95-8.94V97.27A9,9,0,0,0,511.71,88.32Zm6.19,189.89a6.19,6.19,0,0,1-6.19,6.18H433a6.18,6.18,0,0,1-6.18-6.18V97.27A6.19,6.19,0,0,1,433,91.08h78.76a6.2,6.2,0,0,1,6.19,6.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 439.65,
    y: 124.22,
    width: 57.99,
    height: 5.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 440.22,
    y: 133.41,
    width: 29.57,
    height: 2.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M448.4,119.62a6,6,0,1,0-6-6A6,6,0,0,0,448.4,119.62Zm-2.41-5,1.15.81,3.13-5,1.19.74-3.91,6.26-2.37-1.66Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 438.73,
    y: 170.25,
    width: 57.99,
    height: 5.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 439.3,
    y: 179.44,
    width: 29.57,
    height: 2.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M441.5,159.66a6,6,0,1,0,6-6A6,6,0,0,0,441.5,159.66Zm9-2.44-3.91,6.26-2.37-1.66.81-1.15,1.15.8,3.13-5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 437.81,
    y: 214.43,
    width: 57.99,
    height: 5.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 438.38,
    y: 223.62,
    width: 29.57,
    height: 2.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M440.58,203.85a6,6,0,1,0,6-6A6,6,0,0,0,440.58,203.85Zm9-2.45-3.91,6.26L443.34,206l.81-1.16,1.15.81,3.13-5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 472.79,
    cy: 270.58,
    r: 5.52
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoDevelopScreen4);
export default __webpack_public_path__ + "static/media/photoDevelopScreen-4.a5ce570998c5f108bafd4f207e20f90a.svg";
export { ForwardRef as ReactComponent };